import { useEffect, useState } from 'react';
import { isNilOrEmpty } from '../utils';
import {
  useAppContext,
  SET_USER_ID,
  SET_DESIGN_NAME,
  SET_CURRENT_DESIGN,
  SET_HAS_ACTIVE_SUBSCRIPTION,
  SET_DESIGNS,
  SET_SUBSCRIBED_PLAN,
} from '../context/AppContext';
import { useNavigate } from 'react-router-dom';
import DesignPreviewCard from '../components/DesignPreviewCard';
import {
  getDesignsByUser,
  deleteDesign,
  saveDesign,
} from '../api/designAPI';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import { BrowserView, MobileView } from 'react-device-detect';
import UserDashboardMobile from './UserDashboard.mobile';
import LoginBar from '../components/LoginBar';
import { WixClient, checkAuthentication } from '../auth/auth';
import { fetchOrCreateUserId } from '../components/LoginBar';
import { AspectRatio, Center, Button, Container, Text, Group, Modal as MantineModal, Stack, Paper, Box, Loader, Overlay } from '@mantine/core';
import MLDLandingPageImage from '../images/MyLandscapeDesignLanding.png'
import StartDesigningImage from '../images/StartDesigning.png'
import NameDesignModal from '../components/NameDesignModal';
// import { fetchSubscriptionStatus } from '../api/httpAPI';

// Set the app element for react-modal
Modal.setAppElement('#root');

const UserDashboard = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();
  const [selectedDesignId, setSelectedDesignId] = useState(null);
  const [showLandingPage, setShowLandingPage] = useState(true);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showSubscribeNotice, setShowSubscribeNotice] = useState(false);
  const { state, dispatch } = useAppContext();
  const { user, designs } = state;

  useEffect(() => {
    async function checkAuth() {
      const { isLoggedIn, email } = await checkAuthentication();
      
      if (isLoggedIn && email) {
        // Fetch or create userId using the backend
        const _userId = await fetchOrCreateUserId(email);

        dispatch({ type: SET_USER_ID, payload: _userId });
        setIsLoggedIn(true)
      }
    }
    checkAuth();
  }, []);

  useEffect(() => {
    if (isLoggedIn) {
      const getSubscriptions = async () => {
        try {
          setIsLoading(true);
          const ordersList = await WixClient.orders.memberListOrders();
          const subscription = ordersList.orders.find(order => order.status === 'ACTIVE');
          console.log('subscription: ', JSON.stringify(subscription));
          dispatch({ type: SET_HAS_ACTIVE_SUBSCRIPTION, payload: !!subscription });
          dispatch({ type: SET_SUBSCRIBED_PLAN, payload: subscription.planId });
        } catch (error) {
          console.error('Error getting subscriptions:', error);
        } finally {
          setIsLoading(false);
        }
      }

      getSubscriptions()
    }
  }, [isLoggedIn])

  const handleCreate = () => {
    setIsModalOpen(true);
  };

  // Duplicate the selected design
  const handleDuplicateSelected = async (designId) => {
    if (!user.id) {
      toast.error('No user ID found.');
      return;
    }

    const currentDesign = designs.find(design => design.designId === designId);
    if (!currentDesign) {
      toast.error('Design not found.');
      return;
    }
    const duplicateDesign = {
      ...currentDesign,
      designId: undefined,
      designName: `${currentDesign.designName} (Copy)`,
    }

    try {
      const response = await saveDesign(duplicateDesign);
      console.log('Design duplicated successfully:', response);
      await fetchDesigns();
      toast.success('Design duplicated successfully!');
    } catch (error) {
      console.log('Falied to duplicate design:', error);
      toast.error('Failed to duplicate design.');
    }
  };

  // Edit the selected design
  const handleEditSelected = async () => {
    if (!user.id) {
      toast.error('No user ID found.');
      return;
    }

    if (!selectedDesignId) {
      toast.error('No design selected for editing.');
      return;
    }
    try {
      // console.log('Fetching design:', selectedDesignId);
      // const design = await getSpecificDesign(selectedDesignId);
      // console.log('Fetched design:', JSON.stringify(design));

      const design = designs.find(design => design.designId === selectedDesignId);

      if (!design) {
        toast.error('Design not found.');
        return;
      }

      dispatch({ type: SET_CURRENT_DESIGN, payload: design });

      setSelectedDesignId(null);

      toast.success('Design loaded for editing.');
      navigate('/choose-plants');
    } catch (error) {
      console.error('Error editing design:', error);
      toast.error('Failed to edit design.');
    }
  };

  // Delete the selected design
  const handleDeleteSelected = async () => {
    if (!user.id) {
      toast.error('No user ID found.');
      return;
    }

    if (!selectedDesignId) {
      console.error('No design selected for deletion.');
      return;
    }

    try {
      console.log('Deleting design: ', selectedDesignId);
      const response = await deleteDesign(user.id, selectedDesignId);
      console.log('Design deleted successfully:', response);

      await fetchDesigns();

      setSelectedDesignId(null);
    } catch (error) {
      console.error('Failed to delete design:', error);
    }
  };

  // Take the user back to the website
  const backToWebsite = () => {
    window.location.href = 'https://www.mylandscapedesign.com';
  };

  // Get all designs made by the current userId
  const fetchDesigns = async () => {
    if (!user.id) {
      return;
    }

    try {
      const userDesigns = await getDesignsByUser(user.id);
      dispatch({ type: SET_DESIGNS, payload: userDesigns });
    } catch (error) {
      console.error(`Failed to load user ${user.id}'s designs:`, error);
    }
  };

  // loading the page causes anything in state to be reset
  useEffect(() => {
    // dispatch({ type: RESET_STATE });
  }, []);

  useEffect(() => {
    fetchDesigns();
  }, [user.id]);

  // Modal functionalities
  const handleSubmit = (designName) => {
    if (designName.trim()) {
      dispatch({ type: SET_DESIGN_NAME, payload: designName });
    }
    navigate('/zone');
  };

  const handleSkip = () => {
    navigate('/zone');
  };

  const navigateToSubscriptionPage = () => {
    window.open('https://www.mylandscapedesign.com/pricing-plans', '_blank');
  }

  // useEffect(() => {
  //   async function checkSubscription() {
  //     const status = await fetchSubscriptionStatus();
  //     if (status?.hasActiveSubscription) {
  //       console.log('User has an active subscription:', status);
  //     } else if (userId === 'adminUser') {
  //       console.log('Admin user does not need a subscription.');
  //     } else {
  //       console.log('User does not have an active subscription.');
  //       toast.error('Please subscribe to access this feature.');
  //       setTimeout(() => {
  //         navigate('https://www.mylandscapedesign.com/plans-pricing');
  //       }, 5000);
  //     }
  //   }
  //   checkSubscription();
  // }, []);

  const renderCenterContent = () => {
    const handleStartDesigningPress = () => {
      if (user.hasActiveSubscription) {
        setShowLandingPage(false);
        handleCreate();
      } else {
        setShowSubscribeNotice(true);
        // navigate('/zone');

      }
    }

    if (showLandingPage) {
      return (
        <AspectRatio ratio={3781/2656} mx="auto" width="100%">
          <div style={{ position: 'relative' }}>
            <img
              src={MLDLandingPageImage}
              alt="Welcome to My Landscape Design!"
              style={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
            
            <Center style={{ position: 'absolute', bottom: 0, left: 0, width: '100%', height: '38%' }}>
              <Button
                variant="filled"
                color="var(--median-window-color)"
                styles={() => ({
                  root: {
                    fontSize: 'min(1.5vw, 24px)',
                    padding: 'min(1vw, 10px) min(1.5vw, 10px)',
                    height: 'auto', 
                    width: '32%',
                    border: '4px solid #193125',
                    borderRadius: '20px',
                  }
                })}
                onClick={handleStartDesigningPress}
              >
                <AspectRatio ratio={654/132} mx="auto" width="100%">
                  <img src={StartDesigningImage} alt="Start Designing" />
                </AspectRatio>
              </Button>
            </Center>
          </div>
        </AspectRatio>
      )
    } else if (isNilOrEmpty(designs)) {
      return <></>
    } else {
      return (
        <Stack w="100%" align="center" style={{ paddingTop: '20px' }}>
          {designs.map((design) => (
            <DesignPreviewCard
              key={design.designId}
              design={design}
              isSelected={design.designId === selectedDesignId}
              onClick={() => setSelectedDesignId(design.designId)}
            />
          ))}
        </Stack>
      )
    }
  }

  const renderSubscribeNotice = () => {
    return (
      <MantineModal
        padding="xs"
        opened={showSubscribeNotice}
        onClose={() => setShowSubscribeNotice(false)}
        centered
        withCloseButton={false}
      >
        <Text size="sm" mb="xs" fw={500}>
          Please subscribe to access this feature!
        </Text>

        <Group justify="center">
          <Button onClick={navigateToSubscriptionPage}>Subscribe</Button>
        </Group>
      </MantineModal>
    )
  }

  const renderCreateNewDesignButton = () => {
    return (
      <Button 
        onClick={handleCreate} 
        variant="filled"
        color="#b8bab5"
        autoContrast
        fullWidth={true}
        styles={() => ({
          root: {
            height: 'auto',
            minHeight: '44px',
            padding: '12px 16px',
            fontSize: '16px',
            width: 'auto'
          }
        })}
      >
        <Text style={{ 
          whiteSpace: 'normal', 
          textAlign: 'center', 
          width: '100%', 
          display: 'inline-block'
        }}>
          Create New Design
        </Text>
      </Button>
    )
  }

  const renderSavedDesignsButton = () => {
    return (
      <Button 
        onClick={() => setShowLandingPage(false)}
        variant="filled"
        color="#b8bab5"
        autoContrast
        fullWidth={true}
        styles={() => ({
          root: {
            height: 'auto',
            minHeight: '44px',
            padding: '12px 16px',
            fontSize: '16px',
            width: 'auto'
          }
        })}
      >
        <Text style={{ 
          whiteSpace: 'normal', 
          textAlign: 'center', 
          width: '100%', 
          display: 'inline-block'
        }}>
          Saved Designs
        </Text>
      </Button>
    )
  }

  const renderDuplicateSelectedButton = () => {
    return (
      <Button
        onClick={() => handleDuplicateSelected(selectedDesignId)}
        disabled={!selectedDesignId}
        variant="filled"
        color="#b8bab5"
        autoContrast
        fullWidth={true}
        styles={() => ({
          root: {
            height: 'auto',
            minHeight: '44px',
            padding: '12px 16px',
            fontSize: '16px',
            width: 'auto'
          }
        })}
      >
        <Text style={{ 
          whiteSpace: 'normal', 
          textAlign: 'center', 
          width: '100%', 
          display: 'inline-block'
        }}>
          Duplicate Selected
        </Text>
      </Button>
    )
  }

  const renderEditSelectedButton = () => {
    return (
      <Button
        onClick={handleEditSelected}
        disabled={!selectedDesignId}
        variant="filled"
        color="#b8bab5"
        autoContrast
        fullWidth={true}
        styles={() => ({
          root: {
            height: 'auto',
            minHeight: '44px',
            padding: '12px 16px',
            fontSize: '16px',
            width: 'auto'
          }
        })}
      >
        <Text style={{ 
          whiteSpace: 'normal', 
          textAlign: 'center', 
          width: '100%', 
          display: 'inline-block'
        }}>
          Edit Selected
        </Text>
      </Button>
    )
  }

  const renderDeleteSelectedButton = () => {
    return (
      <Button
        onClick={handleDeleteSelected}
        disabled={!selectedDesignId}
        variant="filled"
        color="#b8bab5"
        autoContrast
        fullWidth={true}
        styles={() => ({
          root: {
            height: 'auto',
            minHeight: '44px',
            padding: '12px 16px',
            fontSize: '16px',
            width: 'auto'
          }
        })}
      >
        <Text style={{ 
          whiteSpace: 'normal', 
          textAlign: 'center', 
          width: '100%', 
          display: 'inline-block'
        }}>
          Delete Selected
        </Text>
      </Button>
    )
  }

  const renderBackToWebsiteButton = () => {
    return (
      <Button 
        onClick={backToWebsite}
        variant="filled"
        color="#b8bab5"
        autoContrast
        fullWidth={true}
        styles={() => ({
          root: {
            height: 'auto',
            minHeight: '44px',
            padding: '12px 16px',
            fontSize: '16px',
            width: 'auto'
          }
        })}
      >
        <Text style={{ 
          whiteSpace: 'normal', 
          textAlign: 'center', 
          width: '100%', 
          display: 'inline-block'
        }}>
          Back to MLD.com
        </Text>
      </Button>
    )
  }

  const renderNameDesignModal = () => {
    return (
      <NameDesignModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleSubmit}
        onSkip={handleSkip}
      />
    );
  };

  const renderLoadingOverlay = () => {
    return (
      <Overlay
        visible={isLoading}
        zIndex={1000}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: 'rgba(0, 0, 0, 0.6)'
        }}
      >
        <Stack align="center" gap="md">
          <Loader size="lg" color="white" />
          <Text c="white" size="lg" fw={500}>
            Loading...
          </Text>
        </Stack>
      </Overlay>
    );
  };
console.log('user.subscribedPlan: ', JSON.stringify(user.subscribedPlan));
  return (
    <>
      {isLoading && renderLoadingOverlay()}
      <BrowserView className='full-container' style={{	minWidth: 800 }}>
        <header className='starting-header'>
          <Center>
            {user.id && <h1>Welcome, {user?.nickname}</h1>}
          </Center>
          <LoginBar />
        </header>
        <Box
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'stretch',
            justifyContent: 'space-between',
            backgroundColor: 'var(--background-color)',
            width: '100%',
            flex: 1,
            overflow: 'hidden',
            paddingTop: '10px'
          }}
        >
          <Paper
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-start',
              backgroundColor: 'var(--median-window-color)',
              height: '98%',
              minHeight: '98%',
              width: '20%',
              minWidth: '250px',
              borderRadius: '10px',
              margin: '0 5px',
              padding: '5px',
              overflowY: 'auto'
            }}
          >
            <h2>User Information</h2>
            <Container fluid style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left' }} truncate="end">
              <Text style={{ textAlign: 'left' }}>User: {user?.nickname}</Text>
              <Text style={{ textAlign: 'left' }}>Email: {user?.email}</Text>
              {user?.zipCode && <Text style={{ textAlign: 'left' }}>Zipcode: {user?.zipCode}</Text>}
            </Container>
          </Paper>
          <Container
            fluid 
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'flex-start',
              backgroundColor: 'var(--median-window-color)',
              minHeight: '98%',
              height: '98%',
              width: '100%',
              minWidth: '570px',
              borderRadius: '10px',
              overflow: 'auto',
              margin: '0 5px',
              paddingBottom: '20px'
            }}
          >
            {renderCenterContent()}
            {renderSubscribeNotice()}
          </Container>
          <Paper
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'flex-start',
              backgroundColor: 'var(--median-window-color)',
              height: '98%',
              minHeight: '98%',
              width: '15%',
              minWidth: '180px',
              borderRadius: '10px',
              overflowY: 'auto',
              margin: '0 5px',
              padding: '10px',
              flexWrap: 'nowrap',
              gap: '0'
            }}
          >
          {user.hasActiveSubscription && renderCreateNewDesignButton()}
          {user.hasActiveSubscription && showLandingPage && renderSavedDesignsButton()}
          {!selectedDesignId ? (
            <></>
          ) : (
            <>
              {renderDuplicateSelectedButton()}
              {renderEditSelectedButton()}
              {renderDeleteSelectedButton()}
            </>
          )}
          {renderBackToWebsiteButton()}
          </Paper>
        </Box>
      </BrowserView>
      <MobileView>
        <UserDashboardMobile
          user={user}
          designs={designs}
          selectedDesignId={selectedDesignId}
          setSelectedDesignId={setSelectedDesignId}
          navigate={navigate}
          handleDuplicateSelected={handleDuplicateSelected}
          handleEditSelected={handleEditSelected}
          handleDeleteSelected={handleDeleteSelected}
          handleSubmitGardenName={handleSubmit}
          handleSkipGardenName={handleSkip}
          isLoading={isLoading}
        />
      </MobileView>
      {renderNameDesignModal()}
    </>
  );
};

export default UserDashboard;
